export default {
  date: 'February 14, 2025',
  title: 'New Feature in Getfloorplan: All Styles in One Widget!',
  description: 'A game-changer for real estate visualization',
  id: 'all-styles-in-one-widget',
  jsx: () => (
    <div class='novelty__text'>
      <p>
        We are excited to introduce a new feature in Getfloorplan! Our widget now includes a style switcher that allows you to display various visualization styles in one place. This is a great opportunity for real estate sellers to stand out in the market and attract more attention to their
        listings.
      </p>
      <p>
        <b>What does this mean for you?</b>
      </p>
      <p>With the new style switcher in the widget, potential buyers can instantly view different visualization options. This creates a “wow” effect, highlights the advantages of the property, and simplifies the decision-making process.</p>
      <p>
        <b>What are the benefits of this feature?</b>
      </p>
      <ul style='margin-left: 50px'>
        <li class='margin-none'>All styles in one place – buyers can choose the visualization style they like best.</li>
        <li class='margin-none'>Increased engagement – switching styles makes interacting with the widget more dynamic and enjoyable.</li>
        <li class='margin-none'>Enhanced competitiveness – a unique opportunity to offer clients multiple ways to present real estate.</li>
      </ul>
      <p>
        <b>How to get access?</b>
      </p>
      <p>
        This feature is currently available for pre-order. If you want to be among the first to test and use the new style switcher in your widget, contact us at <a href='mailto:support@getfloorplan.com'>support@getfloorplan.com</a>.
      </p>
      <p>Don’t miss the chance to stand out from the competition and impress future buyers with a modern and stylish approach to real estate visualization! </p>
    </div>
  ),
  thumb: 'news/38.webp',
};
